document.addEventListener('DOMContentLoaded', function () {

  let grid = document.querySelector(".product-grid");
  if (!grid) return;

  // Load layout
  let current = sessionStorage.getItem("display") || "default";
  grid.className = "product-grid " + current;

  // Buttons
  document.querySelectorAll(".switch button").forEach(btn => {
    btn.addEventListener("click", () => {
      let type = "default";

      if (btn.classList.contains("twocol")) type = "two";
      if (btn.classList.contains("singlecol")) type = "single";

      sessionStorage.setItem("display", type);
      grid.className = "product-grid " + type;
    });
  });

});

